// extracted by mini-css-extract-plugin
export const listing = "itemList-module--listing--1rTvy";
export const listHeader = "itemList-module--listHeader--3Gj1r";
export const listTitle = "itemList-module--listTitle--22fsD";
export const listDesc = "itemList-module--listDesc--cQJTH";
export const listTitleText = "itemList-module--listTitleText--c01bK";